import React from "react";
import GrComponentFactory from "../../gr_component_factory";

export default GrComponentFactory.createClass({
  displayName: "UserQuoteHeader",

  propTypes: {
    quoteUrl: React.PropTypes.string.isRequired,
    quoteLiked: React.PropTypes.bool.isRequired,
  },

  getHeaderTextPrefix() {
    return this.props.quoteLiked ? "liked a" : "shared a";
  },

  render() {
    return <span>
      {this.getHeaderTextPrefix()}
      {" "}
      <a href={this.props.quoteUrl}
         className="gr-hyperlink gr-hyperlink--bold">
        quote
      </a>
    </span>;
  },
});
